import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Link, useHistory } from "react-router-dom";
import { FormGroup, Modal, ModalHeader, ModalBody, Label, Button } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import SaveButton from "components/common/Forms/SaveButton";
import { Trans, useTranslation } from "react-i18next";
import { useClient } from "hooks";
import Select from "react-select";
import { createPortal } from 'react-dom';

export default function OrganisationsSelection({ setOnBoarding, onConnect }) {
    const { t } = useTranslation();
    const [organisations, setOrganisations] = useState([]);
    const [selectedOrganisation, setSelectedOrganisation] = useState(null);
    const client = useClient();

    useEffect(() => {
        client.get(`/connected_organisations`).get('data').then((resp) => {
            const _organisations = resp.map((org) => ({ value: org.id, label: org.name }));
            setOrganisations(_organisations);
        });
    }, []);

    const finishSubmit = () => {
        setOnBoarding(true);
        onConnect(selectedOrganisation);
    }

    return (
        <div className="py-1">
            <FormGroup className="my-3">
                <div className="col p-0 text-left">
                    <Label><Trans>Please select an organisation to link with</Trans></Label>
                    <FormGroup>
                        <Select placeholder={t('Select an Organisation')} options={organisations} value={selectedOrganisation} onChange={(e) => setSelectedOrganisation(e ? e.value : null)} />
                    </FormGroup>
                </div>
            </FormGroup>
            <Button color="primary ml-0 w-100" disabled={selectedOrganisation ? false : true} onClick={finishSubmit}><Trans>Continue with the selected Organisation</Trans></Button>
        </div>
    )
}